import React, { useState } from "react";
import { Box, Button, Paper, Stack, Text } from "@mantine/core";
import { IconCopy, IconCheck } from "@tabler/icons-react";
import useLocale from "../../../hooks/useLocale";

// Sits over InitialLoadingScreen (which is position: fixed) when the automatic
// navigation to the provider did not happen. "Continue" retries the redirect;
// "Copy link" lets the user open the provider page themselves.
const TrinsicRedirectFallback = ({ url, onContinue }) => {
  const locale = useLocale("trinsic-redirect");
  const [copied, setCopied] = useState(false);

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
    } catch (e) {
      // Older WebViews: fall back to a hidden textarea + execCommand
      const el = document.createElement("textarea");
      el.value = url;
      el.setAttribute("readonly", "");
      el.style.position = "fixed";
      el.style.opacity = "0";
      document.body.appendChild(el);
      el.select();
      try {
        document.execCommand("copy");
      } catch (err) {
        /* nothing else to try */
      }
      document.body.removeChild(el);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2500);
  };

  return (
    <Box
      style={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 10,
        padding: 16,
        paddingBottom: 60, // stay clear of the app footer
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Paper p="md" radius="md" shadow="md" withBorder style={{ width: "100%", maxWidth: 360 }}>
        <Stack spacing="sm">
          <Text ta="center" fz="sm" c="dimmed">
            {locale.title}
          </Text>
          <Button size="md" fullWidth onClick={onContinue}>
            {locale.continueButton}
          </Button>
          <Button
            size="md"
            fullWidth
            variant="subtle"
            onClick={copyLink}
            leftIcon={copied ? <IconCheck size={18} /> : <IconCopy size={18} />}
          >
            {copied ? locale.linkCopied : locale.copyLink}
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default TrinsicRedirectFallback;
